export const purchaseReasonList = ['spare', 'upgrade'] as const;
export type PurchaseReasonType = typeof purchaseReasonList[number];

export function formatPurchaseReason(status: PurchaseReasonType): string {
    return status.charAt(0).toUpperCase() + status.slice(1);
}
